export function securityCode(number: string) {
  return number.replace(/\D/g, '').slice(0, 4);
}

export function expirationDate(value: string): string {

  const digitsOnly = value.replace(/\D/g, '');
  const month = digitsOnly.slice(0, 2);
  const year = digitsOnly.slice(2, 6);

  let result = month;
  if (year.length) {
    result += '/' + year;
  }

  return result;
}

export function cardNumber(value: string): string {

  const digitsOnly = value.replace(/\D/g, '');

  return digitsOnly
    .slice(0, 16)
    .replace(/(.{4})/g, '$1 ')
    .trim();
}